import { render, staticRenderFns } from "./DischargeTransferASAM.vue?vue&type=template&id=7b6e483e"
import script from "./DischargeTransferASAM.vue?vue&type=script&lang=js"
export * from "./DischargeTransferASAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports